module.exports = __webpack_public_path__ + "img/music.8970a82c.gif";